import script from "./ResizeHelper.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResizeHelper.vue?vue&type=script&lang=ts&setup=true"

import "./ResizeHelper.vue?vue&type=style&index=0&id=03bf73b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03bf73b6"]])

export default __exports__